import EmailNotificationsTable from './EmailNotificationsTable';

export default EmailNotificationsTable;


// WEBPACK FOOTER //
// ./src/features/organization/pages/email-notifications/email-notifications-table/index.js